import { UnknownAction } from '@reduxjs/toolkit';
import { Field, Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import { Button, Carousel, Row } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { MdContentCopy } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from 'react-share';
import { Rating } from 'react-simple-star-rating';
import { toast } from 'react-toastify';
import PropertySample from '../../assets/images/PropertySample.jpg';
import ownerimg from '../../assets/images/avatar.png';
import veriafied from '../../assets/images/veriafied.jpg';
import { IProperty } from '../../pages/Listings/Listings';
import SignIn from '../../pages/Login/Signin';
import SignInPopupHOC from '../../pages/Login/hoc/SigninHoc';
import SignUp from '../../pages/SignUp/Signup';
import SignUpPopupHOC from '../../pages/SignUp/hoc/SignupHoc';
import {
  fetchCalenderEvent,
  resetFetchCalenderState,
} from '../../redux/slices/CalenderSlice';
import {
  deleteFavProperty,
  postFavProperty,
  resetListingState,
} from '../../redux/slices/ListingSlice';
import {
  addReviewsProperty,
  approveProperty,
  fetchPropertyById,
  fetchSellPropertyById,
  resetpropertyApproveState,
  resetReviewState,
  setIsFavouritePropertyDetail,
  setIsNotFavouritePropertyDetail,
} from '../../redux/slices/PropertySlice';
import FormikFieldStarRating from '../../utils/FormikFieldStarRating';
import FormikFieldTextArea from '../../utils/FormikFormTextArea';
import { usePermissions } from '../../utils/Permission/Permission';
import {
  ToastType,
  showToastMessage,
  toastDefaults,
} from '../../utils/ToastOptionCommon';
import axiosCall from '../../utils/axiosCall';
import callBackendAPI from '../../utils/callBackendAPI';
import { formatPhoneNumber } from '../../utils/common';
import Loader from '../CommonComponents/Loader/Loader';
import CalenderViewModal from './CalenderViewModal/CalenderViewModal';
import CalenderPopupHOC from './CalenderViewModal/hoc/CalenderPopupHoc';
import { ProfileViewModal } from './ProfileViewModal/ProfileViewModal';
import './PropertyDetail.scss';
import DocumentPopupHOC from './DocumentViewModal/hoc/DocumentPopupHoc';
import DocumentViewModal from './DocumentViewModal/DocumentViewModal';
import Input from 'react-phone-number-input/input';
import { dealTypeEnum, proprertyViewData } from '../../constants/Property';
import {
  isUserAuthenticated,
  loggedInUserState,
} from '../../redux/slices/LoginSlice';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import Busy from '../../assets/gif/busy.gif';
import {
  FaHome,
  FaBed,
  FaBath,
  FaRulerCombined,
  FaBuilding,
  FaLayerGroup,
  FaCompass,
  FaHourglassHalf,
  FaCalendarAlt,
  FaCouch,
  FaKey,
  FaClipboardCheck,
  FaFileAlt,
  FaCheckCircle,
  FaTimesCircle,
} from 'react-icons/fa';
import SEO from '../SEO/SEO';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

interface IProps {
  calenderToggleHandler: () => void;
  showCalenderPopup: boolean;
  signInToggleHandler: () => void;
  showSignInPopup: boolean;
  signUpToggleHandler: () => void;
  showSignUpPopup: boolean;
  showDocumentPopup: boolean;
  documentToggleHandler: () => void;
}

export interface IAmenities {
  id: number;
  name: string;
  order: number;
  icon: string;
  _id: string;
}

export interface IRoom {
  name: string;
  price: number;
  bathroomType: string;
  amenities: Array<IAmenities>;
  depositMoney: number;
  cleaningCharges: number;
  petFees: number;
  availableFrom: string;
  _id: string;
  imagesLink: string[];
}

interface ChatData {
  Name: string;
  Phone: string;
  Email: string;
  Message: string;
  senderId: string;
  PropertyId: string;
}

// type propertyStateData = {
//   loader: boolean;
//   propertyDetail: IProperty;
// };

const PropertyDetail = (props: IProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const propertyDetail: IProperty = useSelector(
    (state: any) => state.property.property
  );
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [owner, setLandLoard] = useState<any>();
  const [events, setEvents] = useState([]);
  const [ownerRating, setLandoardRating] = useState<number>();
  const isLoading = useSelector((state: any) => state.property.isLoading);
  const loggedUser = useSelector((state: any) => state.login?.userData);
  const [favId, setFavId] = useState<string>('');
  const isAuthenticated = useSelector(isUserAuthenticated);
  const { addReviewsLoading, addReviewsSuccess, addReviewsError } = useSelector(
    (state: any) => state.property
  );
  const { hasPermission } = usePermissions();
  const { loading, success, error, calenderEvents } = useSelector(
    (state: any) => state.calender
  );
  const { dealType, currentPropertyId }: any = useParams();
  const [contactLoading, setContactLoading] = useState(false);
  const [favLoading, setFavLoading] = useState(false);
  const [selectedRoomId, setSelectedRoomId] = useState<string | null>(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');
  const [lightboxOpen, setLightboxOpen] = useState<boolean>(false);
  const [activeImageIndex, setActiveImageIndex] = useState<number>(0);

  const {
    postFavPropertyError,
    postFavPropertySuccess,
    deleteFavPropertyError,
    deleteFavPropertySuccess,
    deleteFavPropertyLoading,
    postFavPropertyLoading,
  } = useSelector((state: any) => state.listing);
  const {
    approvePropertySuccess,
    approvePropertyLoading,
    approvePropertyError,
  } = useSelector((state: any) => state.property);

  const [phoneValue, setPhoneValue] = useState<any>('');

  const location: any = useLocation();
  // const dealType = location?.state?.dealType ?? 'rent';

  const propertyUrl = window.location.href;

  const isRental = dealType !== dealTypeEnum.Sell;

  const locationName =
    propertyDetail?.address?.city || propertyDetail?.city || '';

  const stateName =
    propertyDetail?.address?.state || propertyDetail?.state || '';

  const propertyTitle = propertyDetail?.title || 'Property';

  const selectedRoomForSEO =
    propertyDetail?.rooms?.find((room) => room._id === selectedRoomId) ||
    propertyDetail?.rooms?.[0];

  const rentalPrice =
    selectedRoomForSEO?.price ?? propertyDetail?.price ?? null;

  const seoImage =
    selectedRoomForSEO?.imagesLink?.[0] ||
    propertyDetail?.imagesLink?.[0] ||
    '';

  const seoTitle = isRental
    ? `${propertyTitle} for Rent in ${locationName}${stateName ? `, ${stateName}` : ''}${rentalPrice ? ` | ₹${rentalPrice}/month` : ''} | GrhamDeal`
    : `${propertyTitle} for Sale in ${locationName}${stateName ? `, ${stateName}` : ''} | GrhamDeal`;

  const cleanDescription = (propertyDetail?.description || '')
    .replace(/<[^>]*>/g, '')
    .replace(/\s+/g, ' ')
    .trim();

  const seoDescription = isRental
    ? [
        `${propertyTitle} available for rent in ${locationName}${stateName ? `, ${stateName}` : ''}.`,
        rentalPrice ? `Rent ₹${rentalPrice} per month.` : '',
        selectedRoomForSEO?.bathroomType === 'private'
          ? 'Private bathroom.'
          : '',
        'View photos, amenities and rental details on GrhamDeal.',
      ]
        .filter(Boolean)
        .join(' ')
    : cleanDescription ||
      `${propertyTitle} available for sale in ${locationName}${stateName ? `, ${stateName}` : ''}. View property details on GrhamDeal.`;

  const canonicalUrl = `https://grhamdeal.com/property-detail/${dealType}/${currentPropertyId}`;

  const propertySchema = propertyDetail?._id
    ? {
        '@context': 'https://schema.org',
        '@type': 'Accommodation',

        name: propertyTitle,

        description: seoDescription,

        url: canonicalUrl,

        image: selectedRoomForSEO?.imagesLink?.length
          ? selectedRoomForSEO.imagesLink
          : propertyDetail.imagesLink || [],

        address: {
          '@type': 'PostalAddress',

          streetAddress:
            propertyDetail.address?.addressLine1 ||
            propertyDetail.address?.street ||
            '',

          addressLocality:
            propertyDetail.address?.city || propertyDetail.city || '',

          addressRegion:
            propertyDetail.address?.state || propertyDetail.state || '',

          postalCode: propertyDetail.address?.zip || propertyDetail.zip || '',

          addressCountry: 'IN',
        },

        ...(rentalPrice !== null && {
          offers: {
            '@type': 'Offer',

            price: rentalPrice,

            priceCurrency: 'INR',

            url: canonicalUrl,

            availability:
              propertyDetail.status === 'Available'
                ? 'https://schema.org/InStock'
                : 'https://schema.org/OutOfStock',

            priceSpecification: {
              '@type': 'UnitPriceSpecification',
              price: rentalPrice,
              priceCurrency: 'INR',
              unitText: 'MONTH',
            },
          },
        }),

        ...(propertyDetail.amenities?.length > 0 && {
          amenityFeature: propertyDetail.amenities.map((amenity) => ({
            '@type': 'LocationFeatureSpecification',
            name: amenity.name,
            value: true,
          })),
        }),
      }
    : undefined;

  useEffect(() => {
    window.scrollTo(0, 0);
    if (location.state) {
      setSelectedRoomId(location.state as string);
    }
  }, [location]);

  useEffect(() => {
    if (addReviewsSuccess) {
      showToastMessage('Review Added Successfully', ToastType.Success);
      fetchPropertyData();
    }
    dispatch(resetReviewState(null));
  }, [addReviewsSuccess]);

  useEffect(() => {
    if (addReviewsError) {
      showToastMessage('Review Submit Failed', ToastType.Error);
    }
    dispatch(resetReviewState(null));
  }, [addReviewsError]);

  useEffect(() => {
    if (error) {
      showToastMessage(
        'Error Ocurred While Fetching Calender',
        ToastType.Error
      );
    }
    dispatch(resetFetchCalenderState(null));
  }, [error]);

  useEffect(() => {
    // setEvents(
    //   calenderEvents?.map((e: any) => {
    //     return {
    //       title: e.title,
    //       start: new Date(e.start),
    //       end: new Date(e.end),
    //     };
    //   })
    // );
  }, [calenderEvents]);

  useEffect(() => {
    if (currentPropertyId === undefined || currentPropertyId === null) {
      navigate('/');
    }
    dispatch(
      fetchCalenderEvent({
        body: { PropertyId: currentPropertyId },
      }) as unknown as UnknownAction
    );
  }, []);

  useEffect(() => {
    if (postFavPropertySuccess) {
      toast.success('Marked as Favorite', toastDefaults());
    }
    dispatch(setIsFavouritePropertyDetail({ id: favId }));
    dispatch(resetListingState({}));
  }, [postFavPropertySuccess]);

  useEffect(() => {
    if (deleteFavPropertySuccess) {
      toast.success('Unmarked from Favorite', toastDefaults());
    }
    dispatch(setIsNotFavouritePropertyDetail({ id: favId }));
    dispatch(resetListingState({}));
  }, [deleteFavPropertySuccess]);

  // useEffect(() => {
  //   if (approvePropertySuccess) {
  //     toast.success('Property Approved Successfully', toastDefaults());
  //     resetpropertyApproveState();
  //   }
  // }, [approvePropertySuccess]);

  useEffect(() => {
    if (approvePropertyError) {
      toast.error('Failed Approving Property', toastDefaults());
      resetpropertyApproveState();
    }
  }, [approvePropertyError]);

  useEffect(() => {
    if (postFavPropertyError) {
      toast.error('Failed Faving Property', toastDefaults());
    }
    dispatch(resetListingState(null));
  }, [postFavPropertyError]);

  useEffect(() => {
    if (deleteFavPropertyError) {
      toast.error('Failed Un-Faving Property', toastDefaults());
    }
    dispatch(resetListingState(null));
  }, [deleteFavPropertyError]);

  const [selectedRoom, setSelectedRoom] = useState<IRoom>({
    name: '',
    price: 0,
    bathroomType: '',
    amenities: [{ id: 0, name: '', order: -1, icon: '', _id: '' }],
    depositMoney: 0,
    cleaningCharges: 0,
    petFees: 0,
    availableFrom: '',
    _id: '',
    imagesLink: [],
  });

  const [reviewTitle, setReviewTitle] = useState<string>(
    `${propertyDetail.review ? propertyDetail.review?.length : 0} Reviews`
  );
  const handleRoomSelection = (id: string) => {
    let room = propertyDetail.rooms?.filter((e) => e._id === id)[0];
    setSelectedRoom(() => room);
    setSelectedRoomId(id);
  };

  const fetchPropertyData = () => {
    dispatch(
      dealType === dealTypeEnum.Sell
        ? (fetchSellPropertyById({
            Id: currentPropertyId,
            section: -999,
          }) as unknown as UnknownAction)
        : (fetchPropertyById({
            Id: currentPropertyId,
            section: -999,
          }) as unknown as UnknownAction)
    );
  };

  useEffect(() => {
    if (currentPropertyId) {
      fetchPropertyData();
    }
  }, []);

  useEffect(() => {
    setSelectedRoom(
      () =>
        propertyDetail?.rooms?.find((item) => item._id === selectedRoomId) ||
        propertyDetail?.rooms?.[0]
    );
    if (isAuthenticated) {
      if (propertyDetail?.user_id) {
        (async () => {
          const url = `/user/getUserById/${propertyDetail.user_id}`;
          const response = await axiosCall.get(url);
          // console.log(response.data);
          let user = response.data;
          if (user?.keepPhoneNumberPrivate) {
            user.phoneNo = user?.phoneNo?.toString().replace(/\d/g, '*');
          }
          setLandLoard(() => user);
        })();
        (() => {
          const url = `reviews/ownerRating/${propertyDetail.user_id}`;
          axiosCall
            .get(url)
            .then((response) => {
              setLandoardRating(response.data.avgRating);
            })
            .catch((error) => {
              setLandoardRating(0);
            });
        })();
      }
      setChatData({ ...chatData, PropertyId: propertyDetail?._id });
    }
  }, [propertyDetail]);

  useEffect(() => {
    setReviewTitle(() => `${propertyDetail?.review?.length} Reviews`);
  }, [propertyDetail?.review]);

  let userDetailsLocal = localStorage.getItem('user') ?? '{}';
  let isReviewAdded = propertyDetail?.review?.filter(
    (e) => e.userId === JSON.parse(userDetailsLocal)?._id || ''
  );
  const userData = useSelector(loggedInUserState);

  // console.log(userData);

  // Updated Approve/Reject Logic
  const handleApproveProperty = () => {
    const body = {
      isApproved: true,
      propertyId: propertyDetail._id,
    };
    dispatch(approveProperty({ body }) as unknown as UnknownAction);
  };

  const handleRejectSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!rejectionReason.trim()) {
      toast.error('Please provide a reason for rejection.', toastDefaults());
      return;
    }

    const body = {
      isApproved: false,
      propertyId: propertyDetail._id,
      rejectionReason: rejectionReason.trim(),
    };

    dispatch(approveProperty({ body }) as unknown as UnknownAction);
    setShowRejectModal(false);
    setRejectionReason('');
  };

  const [chatData, setChatData] = useState<Partial<ChatData>>({
    Name: `${userData?.firstName ?? ''} ${userData?.lastName ?? ''}` || '',
    Phone: userData?.phoneNo?.toString() ?? '',
    Email: userData?.userEmail ?? '',
    Message: '',
    senderId: userData?._id,
    PropertyId: propertyDetail?._id,
  });

  const [urlCopied, setUrlCopied] = useState(false);

  useEffect(() => {
    setChatData({
      Name: `${userData?.firstName ?? ''} ${userData?.lastName ?? ''}` || '',
      Phone: userData?.phoneNo?.toString() ?? '',
      Email: userData?.userEmail ?? '',
      Message: '',
      senderId: userData?._id,
      PropertyId: propertyDetail?._id,
    });
    setPhoneValue(() => {
      return userData?.phoneNo?.toString() ?? '';
    });
  }, [propertyDetail?._id, userData]);

  const handleChatInputChange = (e: any) => {
    const { name, value } = e.target;
    setChatData({
      ...chatData,
      [name]: value,
    });
  };

  useEffect(() => {
    setChatData((prev: any) => ({
      ...prev,
      Phone: formatPhoneNumber(phoneValue ?? ''),
    }));
  }, [phoneValue]);

  const withAuth =
    (action: (...args: any[]) => void) =>
    (...args: any[]) => {
      if (isAuthenticated) {
        action(...args);
      } else {
        props.signInToggleHandler();
      }
    };

  const handleChatSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!isAuthenticated) {
      props.signInToggleHandler();
      return;
    }
    try {
      setContactLoading(true);
      const response = await callBackendAPI(
        'POST',
        'messaging/createChat',
        null,
        chatData
      );
      if (response.status === 200) {
        toast.success(
          'Successfully sent the message, Owner will get back to you. ',
          toastDefaults()
        );
      } else {
        toast.error('failed to send message to Landloard...', toastDefaults());
      }

      setChatData({
        Name: `${userData?.firstName ?? ''} ${userData?.lastName ?? ''}` || '',
        Phone: userData?.phoneNo?.toString() ?? '',
        Email: userData?.userEmail ?? '',
        Message: '',
        senderId: userData?._id,
        PropertyId: propertyDetail?._id,
      });
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setContactLoading(false);
    }
  };

  const handleShowProfile = withAuth(() => {
    setShowProfileModal(!showProfileModal);
  });

  const handleUnLike = withAuth((idToUnLike: any) => {
    dispatch(
      deleteFavProperty({
        body: {
          user_id: JSON.parse(localStorage.getItem('user') ?? '')._id ?? '',
          propertie_id: idToUnLike,
        },
      }) as unknown as UnknownAction
    );
  });

  const handleLike = withAuth((idToLike: any) => {
    dispatch(
      postFavProperty({
        body: {
          user_id: JSON.parse(localStorage.getItem('user') ?? '')._id ?? '',
          propertie_id: idToLike,
        },
      }) as unknown as UnknownAction
    );
  });

  // Helper to handle image click
  const handleImageClick = (index: number) => {
    setActiveImageIndex(index);
    setLightboxOpen(true);
  };

  // 2. Dynamic slide list helper:
  const getActiveImages = () => {
    if (dealType === dealTypeEnum.Sell) {
      return propertyDetail.imagesLink && propertyDetail.imagesLink.length > 0
        ? propertyDetail.imagesLink
        : [PropertySample];
    }
    const activeRoom = propertyDetail.rooms?.find(
      (room) => room._id === selectedRoom?._id
    );
    return activeRoom?.imagesLink && activeRoom.imagesLink.length > 0
      ? activeRoom.imagesLink
      : [PropertySample];
  };

  const imageList = getActiveImages();
  const lightboxSlides = imageList.map((src: string) => ({ src }));

  return (
    <>
      {propertyDetail?._id && (
        <SEO
          title={seoTitle}
          description={seoDescription}
          canonical={canonicalUrl}
          image={seoImage}
          structuredData={propertySchema}
        />
      )}

      {props.showSignInPopup && (
        <SignIn
          modalClosedSignIn={props.signInToggleHandler}
          modalClosedSignUp={props.signUpToggleHandler}
        />
      )}

      {props.showSignUpPopup && (
        <SignUp
          modalClosedSignUp={props.signUpToggleHandler}
          modalClosedSignIn={props.signInToggleHandler}
        />
      )}
      {showProfileModal && (
        <ProfileViewModal
          onModalClose={() => setShowProfileModal(!showProfileModal)}
          userId={propertyDetail.user_id ?? ''}
          modalHeader="Owner Profile"
          showReview={dealType === dealTypeEnum.Sell ? false : true}
        />
      )}
      {props.showCalenderPopup && (
        <CalenderViewModal
          onModalClosed={() => props.calenderToggleHandler()}
          events={events}
        />
      )}
      {props.showDocumentPopup && (
        <DocumentViewModal
          onModalClosed={() => props.documentToggleHandler()}
          fileUrl={propertyDetail.documentsLink[0]}
        />
      )}
      {!propertyDetail.isApproved &&
        propertyDetail.verificationStatus === 'REJECTED' && (
          <div className="alert alert-danger border-danger d-flex align-items-start gap-3 p-3 mb-4 rounded shadow-sm">
            <div className="flex-shrink-0">
              <svg
                height="24"
                width="24"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="text-danger"
              >
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
              </svg>
            </div>
            <div className="flex-grow-1">
              <h5 className="alert-heading text-danger font-weight-bold mb-1">
                Action Required: Property Listing Rejected
              </h5>
              <p className="mb-2 text-dark">
                {propertyDetail.rejectionReason ||
                  'No specific reason was provided by the administrator.'}
              </p>
              <small className="text-muted">
                Please update your property details or upload the correct
                documents according to the feedback above, then re-submit for
                review.
              </small>
            </div>
          </div>
        )}
      {approvePropertyLoading || isLoading || addReviewsLoading || loading ? (
        <div style={{ marginTop: '50%' }}>
          <Loader />
        </div>
      ) : (
        <div className="details-page">
          <div className="details-header bg-white border-bottom shadow-sm py-4">
            <div className="container">
              <div className="d-flex flex-column flex-lg-row align-items-lg-start justify-content-lg-between gap-3">
                {/* LEFT CONTENT */}
                <div className="details-left flex-grow-1">
                  {/* Badges & Views Header */}
                  <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
                    {propertyDetail?.isFeaturedProperty && (
                      <span className="badge bg-warning text-dark px-2.5 py-1 rounded-pill fw-semibold">
                        ⭐ Featured
                      </span>
                    )}

                    {propertyDetail?.status && (
                      <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-2.5 py-1 rounded-pill fw-medium">
                        {propertyDetail.status}
                      </span>
                    )}

                    {/* Views Counter (Owner Only) */}
                    {userData?.currentRole?.toLowerCase() === 'owner' &&
                      userData?._id === propertyDetail?.user_id && (
                        <span className="badge bg-light text-muted border px-2.5 py-1 rounded-pill fw-normal d-inline-flex align-items-center gap-1">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 5C5 5 2 12 2 12C2 12 5 19 12 19C19 19 22 12 22 12C22 12 19 5 12 5Z"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          {propertyDetail.views || 0} views
                        </span>
                      )}
                  </div>

                  {/* Title */}
                  <h1 className="fs-3 fw-bold text-dark mb-2">
                    {propertyDetail?.title ?? '-'}
                  </h1>

                  {/* Address */}
                  <p className="text-muted small d-flex align-items-center gap-1 mb-3">
                    <span className="text-primary">📍</span>
                    <span>
                      {[
                        propertyDetail?.address?.street,
                        propertyDetail?.address?.city,
                        propertyDetail?.address?.state,
                        propertyDetail?.address?.zip,
                      ]
                        .filter(Boolean)
                        .join(', ') || '-'}
                    </span>
                  </p>

                  {/* Integrated Description Snippet */}
                  {propertyDetail?.description && (
                    <p
                      className="text-secondary small mb-0 lh-base"
                      style={{ maxWidth: '720px' }}
                    >
                      {propertyDetail.description}
                    </p>
                  )}
                </div>

                {/* RIGHT ACTIONS */}
                <div className="details-right d-flex align-items-center gap-2 align-self-start mt-2 mt-lg-0">
                  {/* SHARE DROPDOWN */}
                  <div className="dropdown">
                    <button
                      type="button"
                      className="btn btn-outline-light text-dark border-light-subtle rounded-circle p-2 shadow-sm d-flex align-items-center justify-content-center"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      title="Share property"
                      style={{ width: '40px', height: '40px' }}
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.5 4.5C17.5 6.57031 15.8203 8.25 13.75 8.25C12.6172 8.25 11.6016 7.78125 10.8984 6.96094L7.38281 8.71875C7.46094 8.99219 7.5 9.26562 7.5 9.5C7.5 9.77344 7.46094 10.0469 7.38281 10.3203L10.8984 12.0391C11.6016 11.2578 12.6172 10.75 13.75 10.75C15.8203 10.75 17.5 12.4297 17.5 14.5C17.5 16.5703 15.8203 18.25 13.75 18.25C11.6797 18.25 10 16.5703 10 14.5C10 14.2656 10 13.9922 10.0781 13.7188L6.5625 11.9609C5.85938 12.7812 4.84375 13.25 3.75 13.25C1.67969 13.25 0 11.5703 0 9.5C0 7.42969 1.67969 5.75 3.75 5.75C4.84375 5.75 5.85938 6.25781 6.5625 7.03906L10.0781 5.32031C10 5.04688 10 4.77344 10 4.5C10 2.42969 11.6797 0.75 13.75 0.75C15.8203 0.75 17.5 2.42969 17.5 4.5Z"
                          fill="currentColor"
                        />
                      </svg>
                    </button>

                    <ul className="dropdown-menu dropdown-menu-end shadow-sm border-light-subtle rounded-3 p-2">
                      <li>
                        <FacebookShareButton
                          url={propertyUrl}
                          className="dropdown-item d-flex align-items-center gap-2 rounded-2 py-1.5"
                        >
                          <FacebookIcon size={24} round />
                          <span className="small font-medium">Facebook</span>
                        </FacebookShareButton>
                      </li>
                      <li>
                        <TwitterShareButton
                          url={propertyUrl}
                          title={propertyDetail?.title}
                          className="dropdown-item d-flex align-items-center gap-2 rounded-2 py-1.5"
                        >
                          <XIcon size={24} round />
                          <span className="small font-medium">Twitter</span>
                        </TwitterShareButton>
                      </li>
                      <li>
                        <LinkedinShareButton
                          url={propertyUrl}
                          className="dropdown-item d-flex align-items-center gap-2 rounded-2 py-1.5"
                        >
                          <LinkedinIcon size={24} round />
                          <span className="small font-medium">LinkedIn</span>
                        </LinkedinShareButton>
                      </li>
                      <li>
                        <WhatsappShareButton
                          url={propertyUrl}
                          title={propertyDetail?.title}
                          separator=":: "
                          className="dropdown-item d-flex align-items-center gap-2 rounded-2 py-1.5"
                        >
                          <WhatsappIcon size={24} round />
                          <span className="small font-medium">WhatsApp</span>
                        </WhatsappShareButton>
                      </li>
                    </ul>
                  </div>

                  {/* COPY LINK */}
                  <CopyToClipboard
                    onCopy={() => {
                      setUrlCopied(true);
                      showToastMessage(
                        'Copied to your clipboard',
                        ToastType.Success
                      );
                    }}
                    text={propertyUrl}
                  >
                    <button
                      type="button"
                      className="btn btn-outline-light text-dark border-light-subtle rounded-circle p-2 shadow-sm d-flex align-items-center justify-content-center"
                      title="Copy property link"
                      style={{ width: '40px', height: '40px' }}
                    >
                      <MdContentCopy size={18} />
                    </button>
                  </CopyToClipboard>

                  {/* WISHLIST BUTTON */}
                  {propertyDetail?.isFavoriteForThisUser ? (
                    <button
                      type="button"
                      className="btn btn-outline-danger border-danger-subtle rounded-circle p-2 shadow-sm d-flex align-items-center justify-content-center"
                      onClick={() => handleUnLike(propertyDetail._id)}
                      title="Remove from wishlist"
                      style={{ width: '40px', height: '40px' }}
                    >
                      {deleteFavPropertyLoading ? (
                        <div
                          className="spinner-border spinner-border-sm text-danger"
                          role="status"
                        />
                      ) : (
                        <FaHeart size={18} className="text-danger" />
                      )}
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-outline-light text-secondary border-light-subtle rounded-circle p-2 shadow-sm d-flex align-items-center justify-content-center"
                      onClick={() => handleLike(propertyDetail._id)}
                      title="Add to wishlist"
                      style={{ width: '40px', height: '40px' }}
                    >
                      {postFavPropertyLoading ? (
                        <div
                          className="spinner-border spinner-border-sm"
                          role="status"
                        />
                      ) : (
                        <FaRegHeart size={18} />
                      )}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* <>{console.log(propertyDetail)}</> */}
          <div className="property-deatils bg-white">
            <div className="container-sm">
              <div className="row">
                <div className="col-12 col-md-9">
                  <div className="box-view responsive-carousel-container position-relative">
                    {dealType === dealTypeEnum.Sell ? (
                      <Carousel
                        activeIndex={activeImageIndex}
                        onSelect={(idx) => setActiveImageIndex(idx)}
                      >
                        {propertyDetail.imagesLink &&
                        propertyDetail.imagesLink.length > 0 ? (
                          propertyDetail.imagesLink.map(
                            (image: string, i: number) => (
                              <Carousel.Item key={i}>
                                <img
                                  src={image}
                                  alt={`${propertyTitle} for sale in ${locationName}`}
                                  className="carousel-property-img"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => handleImageClick(i)}
                                />
                              </Carousel.Item>
                            )
                          )
                        ) : (
                          <Carousel.Item key="default">
                            <img
                              src={PropertySample}
                              alt={`${propertyTitle} for sale in ${locationName}`}
                              className="carousel-property-img"
                              style={{ cursor: 'pointer' }}
                              onClick={() => handleImageClick(0)}
                            />
                          </Carousel.Item>
                        )}
                      </Carousel>
                    ) : (
                      <Carousel
                        activeIndex={activeImageIndex}
                        onSelect={(idx) => setActiveImageIndex(idx)}
                      >
                        {(() => {
                          const activeRoom = propertyDetail.rooms?.find(
                            (room) => room._id === selectedRoom?._id
                          );
                          const roomImages = activeRoom?.imagesLink;

                          if (roomImages && roomImages.length > 0) {
                            return roomImages.map(
                              (image: string, i: number) => (
                                <Carousel.Item key={i}>
                                  <img
                                    src={image}
                                    alt={`${propertyTitle} room in ${locationName}`}
                                    className="carousel-property-img"
                                    style={{
                                      cursor: 'pointer',
                                      pointerEvents: 'auto',
                                    }}
                                    onClick={() => handleImageClick(i)}
                                  />
                                </Carousel.Item>
                              )
                            );
                          }

                          return (
                            <Carousel.Item key="default">
                              <img
                                src={PropertySample}
                                alt={`${propertyTitle} sample`}
                                className="carousel-property-img"
                                style={{
                                  cursor: 'pointer',
                                  pointerEvents: 'auto',
                                }}
                                onClick={() => handleImageClick(0)}
                              />
                            </Carousel.Item>
                          );
                        })()}
                      </Carousel>
                    )}

                    {/* Fullscreen Lightbox Viewer */}
                    <Lightbox
                      open={lightboxOpen}
                      close={() => setLightboxOpen(false)}
                      index={activeImageIndex}
                      slides={lightboxSlides}
                    />
                  </div>

                  {dealType !== dealTypeEnum.Sell && (
                    <div className="units-property box-view h-auto">
                      <h3 className="box-title">Units at this property</h3>
                      <div className="row">
                        {propertyDetail.rooms?.map((values) => {
                          return (
                            <div
                              key={values._id}
                              className={
                                values._id === selectedRoom._id
                                  ? 'col-md-4 selected-room'
                                  : 'col-md-4'
                              }
                              onClick={() => handleRoomSelection(values._id)}
                            >
                              <div className="bg-light rounded-3 p-2 ">
                                <div className="unit-preview">
                                  <img
                                    src={
                                      values.imagesLink[0]
                                        ? values.imagesLink[0]
                                        : PropertySample
                                    } // not getting images
                                    alt="Unit Preview"
                                    className="img-fluid"
                                  />
                                </div>
                                <div className="p-2">
                                  <h6 className="unit-price">
                                    ₹{values.price} / month
                                  </h6>
                                  <h5 className="unit-title">{values.name}</h5>
                                  <ul className="unit-features">
                                    {values.amenities ? (
                                      values.amenities?.map(
                                        (
                                          data: IAmenities | null,
                                          i: number
                                        ) => {
                                          return (
                                            <li key={i}>
                                              <svg
                                                width="14"
                                                height="9"
                                                viewBox="0 0 14 9"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  d="M12.9336 0.566406C13.1797 0.839844 13.1797 1.25 12.9336 1.49609L5.71484 8.71484C5.44141 8.98828 5.03125 8.98828 4.78516 8.71484L1.06641 4.99609C0.792969 4.75 0.792969 4.33984 1.06641 4.09375C1.3125 3.82031 1.72266 3.82031 1.96875 4.09375L5.22266 7.34766L12.0039 0.566406C12.25 0.320312 12.6602 0.320312 12.9062 0.566406H12.9336Z"
                                                  fill="#818181"
                                                />
                                              </svg>
                                              {data?.name ?? '-'}
                                            </li>
                                          );
                                        }
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {(propertyDetail?.buildingDetails ||
                    propertyDetail?.propertyDetails?.buildingDetails) && (
                    <div className="amenities box-view h-auto">
                      <h3 className="box-title mb-3">Building Details</h3>

                      <div className="row g-3">
                        {[
                          {
                            icon: <FaCalendarAlt />,
                            label: 'Year Built',
                            value: (
                              propertyDetail.buildingDetails ||
                              propertyDetail.propertyDetails?.buildingDetails
                            )?.yearBuilt,
                          },
                          {
                            icon: <FaCalendarAlt />,
                            label: 'Last Renovated Year',
                            value: (
                              propertyDetail.buildingDetails ||
                              propertyDetail.propertyDetails?.buildingDetails
                            )?.lastRenovatedYear,
                          },
                          {
                            icon: <FaClipboardCheck />,
                            label: 'Condition',
                            value: (
                              propertyDetail.buildingDetails ||
                              propertyDetail.propertyDetails?.buildingDetails
                            )?.condition,
                          },
                          {
                            icon: <FaFileAlt />,
                            label: 'Renovation Details',
                            value: (
                              propertyDetail.buildingDetails ||
                              propertyDetail.propertyDetails?.buildingDetails
                            )?.renovationDetails,
                          },
                        ].map((item, i) => (
                          <div className="col-md-4 col-sm-6" key={i}>
                            <div className="detail-tile p-3 h-100 shadow-sm rounded bg-white d-flex flex-column align-items-start gap-2">
                              <div className="d-flex align-items-center gap-2 text-primary fs-5">
                                {item.icon}
                                <span className="fw-semibold">
                                  {item.label}
                                </span>
                              </div>
                              <div className="text-muted fs-6">
                                {item.value || '—'}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  <div className="amenities box-view h-auto p-3 p-md-4 rounded-3 shadow-sm border border-light-subtle">
                    {/* Header Section */}
                    <div className="d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom border-2 border-white">
                      <h3 className="box-title mb-0 fs-5 fw-bold text-dark d-flex align-items-center gap-2">
                        <span
                          className="p-2 rounded-circle bg-white shadow-sm d-flex align-items-center justify-content-center"
                          style={{ width: '32px', height: '32px' }}
                        >
                          ✨
                        </span>
                        Amenities
                      </h3>
                    </div>

                    {/* Amenities Grid */}
                    <div className="row g-2">
                      {propertyDetail?.amenities?.map((amenity, i) => {
                        if (amenity?.name?.toLowerCase() === 'others')
                          return null;
                        return (
                          <div key={i} className="col-6 col-sm-4 col-md-3">
                            <div className="d-flex align-items-center p-2 px-3 rounded-3 bg-white border border-light-subtle shadow-sm h-100">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: amenity.icon,
                                }}
                                className="me-2 text-primary d-flex align-items-center justify-content-center"
                                style={{
                                  width: '24px',
                                  height: '24px',
                                  flexShrink: 0,
                                }}
                              ></div>
                              <span
                                className="fw-semibold text-dark small text-truncate"
                                title={amenity.name}
                              >
                                {amenity.name}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {dealType === dealTypeEnum.Sell && (
                    <div className="amenities box-view h-auto">
                      <h3 className="box-title mb-3">Property Details</h3>

                      <div className="row g-3">
                        {[
                          {
                            icon: <FaHome />,
                            label: 'Property Status',
                            value: propertyDetail.is_active ? (
                              <span className="text-success">
                                <FaCheckCircle className="me-1" /> Active
                              </span>
                            ) : (
                              <span className="text-danger">
                                <FaTimesCircle className="me-1" /> Inactive
                              </span>
                            ),
                          },
                          {
                            icon: <FaBed />,
                            label: 'Bedrooms',
                            value: propertyDetail.bedrooms,
                          },
                          {
                            icon: <FaBath />,
                            label: 'Bathrooms',
                            value: propertyDetail.propertyDetails?.bathrooms,
                          },
                          {
                            icon: <FaRulerCombined />,
                            label: 'Carpet Area',
                            value: `${propertyDetail.propertyDetails?.carpetArea} ${propertyDetail.propertyDetails?.carpetAreaUnit}`,
                          },
                          {
                            icon: <FaLayerGroup />,
                            label: 'Super Built-up Area',
                            value: `${propertyDetail.propertyDetails?.superBuiltUpArea} ${propertyDetail.propertyDetails?.superBuiltUpAreaUnit}`,
                          },
                          {
                            icon: <FaBuilding />,
                            label: 'Floor',
                            value: propertyDetail.propertyDetails?.floor,
                          },
                          {
                            icon: <FaBuilding />,
                            label: 'Total Floors',
                            value: propertyDetail.propertyDetails?.totalFloors,
                          },
                          {
                            icon: <FaCompass />,
                            label: 'Facing',
                            value: propertyDetail.propertyDetails?.facing,
                          },
                          {
                            icon: <FaHourglassHalf />,
                            label: 'Property Age',
                            value: propertyDetail.propertyDetails?.propertyAge,
                          },
                          {
                            icon: <FaCalendarAlt />,
                            label: 'Construction Year',
                            value:
                              propertyDetail.propertyDetails?.constructionYear,
                          },
                          {
                            icon: <FaCouch />,
                            label: 'Furnishing Status',
                            value:
                              propertyDetail.propertyDetails?.furnishingStatus,
                          },
                          {
                            icon: <FaKey />,
                            label: 'Possession Status',
                            value:
                              propertyDetail.propertyDetails?.possessionStatus,
                          },
                        ].map((item, i) => (
                          <div className="col-md-4 col-sm-6" key={i}>
                            <div className="detail-tile p-3 h-100 shadow-sm rounded bg-white d-flex flex-column align-items-start gap-2">
                              <div className="d-flex align-items-center gap-2 text-primary fs-5">
                                {item.icon}
                                <span className="fw-semibold">
                                  {item.label}
                                </span>
                              </div>
                              <div className="text-muted fs-6">
                                {item.value || '—'}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {propertyDetail?.p_video_path ? (
                    <div className="property-description box-view h-auto p-3 p-md-4 rounded-3 shadow-sm border border-light-subtle">
                      {/* Header Section */}
                      <div className="d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom border-2 border-white">
                        <h3 className="box-title mb-0 fs-5 fw-bold text-dark d-flex align-items-center gap-2">
                          <span
                            className="p-2 rounded-circle bg-white shadow-sm d-flex align-items-center justify-content-center"
                            style={{ width: '32px', height: '32px' }}
                          >
                            🎬
                          </span>
                          Video Tour
                        </h3>
                      </div>

                      {/* Video Container */}
                      <div className="ratio ratio-16x9 rounded-3 overflow-hidden shadow-sm border border-light-subtle">
                        <iframe
                          src={
                            propertyDetail.p_video_path?.includes('?v=')
                              ? `https://www.youtube.com/embed/${propertyDetail.p_video_path.split('?v=')[1]?.split('&')[0]}`
                              : `https://www.youtube.com/embed/${propertyDetail.p_video_path.split('/').pop()}`
                          }
                          title="Property Video Tour"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                  ) : null}

                  {dealType !== dealTypeEnum.Sell && (
                    <div className="property-reviews box-view h-auto p-3 p-md-4 rounded-3 shadow-sm border border-light-subtle">
                      {/* Header & Tabs */}
                      <div className="d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom border-2 border-white flex-wrap gap-2">
                        <h3 className="box-title mb-0 fs-5 fw-bold text-dark d-flex align-items-center gap-2">
                          <span
                            className="p-2 rounded-circle bg-white shadow-sm d-flex align-items-center justify-content-center"
                            style={{ width: '32px', height: '32px' }}
                          >
                            ⭐
                          </span>
                          {reviewTitle}
                        </h3>

                        <ul className="nav nav-pills bg-light p-1 rounded-pill border">
                          <li className="nav-item">
                            <a
                              className="nav-link active rounded-pill px-3 py-1 fs-6 fw-medium"
                              data-bs-toggle="tab"
                              href="#AllReviews"
                              onClick={() =>
                                setReviewTitle(
                                  () =>
                                    `${propertyDetail.review?.length || 0} Reviews`
                                )
                              }
                            >
                              All Reviews
                            </a>
                          </li>
                          {loggedUser?._id !== propertyDetail?.user_id &&
                            !hasPermission('owner') && (
                              <li className="nav-item">
                                <a
                                  className="nav-link rounded-pill px-3 py-1 fs-6 fw-medium"
                                  data-bs-toggle="tab"
                                  href="#WriteReview"
                                  onClick={() =>
                                    setReviewTitle(() => `Write a review`)
                                  }
                                >
                                  Write a review
                                </a>
                              </li>
                            )}
                        </ul>
                      </div>

                      {/* Tab Content */}
                      <div className="tab-content pt-2">
                        {/* ALL REVIEWS TAB */}
                        <div
                          id="AllReviews"
                          className="tab-pane fade show active"
                        >
                          {propertyDetail?.review?.length > 0 ? (
                            <div className="d-flex flex-column gap-3">
                              {propertyDetail.review.map((reviewDetail, i) => (
                                <div
                                  key={i}
                                  className="d-flex align-items-start p-3 bg-white rounded-3 border border-light-subtle shadow-sm gap-3"
                                >
                                  <img
                                    src={ownerimg}
                                    alt="Reviewer Avatar"
                                    className="rounded-circle object-fit-cover flex-shrink-0 shadow-sm"
                                    style={{ width: '48px', height: '48px' }}
                                  />
                                  <div className="flex-grow-1">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-1 mb-1">
                                      <h6 className="mb-0 fw-bold text-dark">
                                        {reviewDetail.reviewerName}
                                      </h6>
                                      <Rating
                                        initialValue={reviewDetail.rating}
                                        SVGstyle={{
                                          display: 'inline',
                                          height: '16px',
                                          width: '16px',
                                        }}
                                        readonly={true}
                                      />
                                    </div>
                                    <p className="text-secondary small mb-0 lh-base">
                                      {reviewDetail.content}
                                    </p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="text-center py-4 text-muted small bg-light rounded-3 border border-dashed">
                              No reviews submitted yet.
                            </div>
                          )}
                        </div>

                        {/* WRITE REVIEW TAB */}
                        <div id="WriteReview" className="tab-pane fade">
                          {isReviewAdded?.length > 0 ? (
                            <div className="alert alert-info border-0 rounded-3 text-center mb-0">
                              You have already written a review for this
                              property.
                            </div>
                          ) : !loggedUser?.isEmailVerified ? (
                            <div className="alert alert-warning border-0 rounded-3 text-center mb-0">
                              Please verify your email address to leave a
                              review.
                            </div>
                          ) : (
                            <Formik
                              initialValues={{
                                propertyId: '',
                                userId: '',
                                reviewerName: '',
                                rating: 0,
                                title: '',
                                content: '',
                              }}
                              onSubmit={withAuth((values) => {
                                const user = JSON.parse(
                                  localStorage.getItem('user') ?? '{}'
                                );
                                const data = {
                                  propertyId:
                                    currentPropertyId ?? values.propertyId,
                                  userId: user._id ?? values.userId,
                                  reviewerName: `${user.firstName} ${user.lastName}`,
                                  rating: values.rating,
                                  title: values.title,
                                  content: values.content,
                                };

                                dispatch(
                                  addReviewsProperty({
                                    body: data,
                                  }) as unknown as UnknownAction
                                );
                              })}
                            >
                              {() => (
                                <div className="bg-white p-3 p-md-4 rounded-3 border border-light-subtle shadow-sm">
                                  <Form className="d-flex flex-column gap-3">
                                    <div>
                                      <label className="form-label fw-semibold text-dark small mb-1">
                                        Your Rating
                                      </label>
                                      <div className="d-flex align-items-center">
                                        <Field
                                          name="rating"
                                          as={FormikFieldStarRating}
                                        />
                                      </div>
                                    </div>

                                    <div>
                                      <label
                                        htmlFor="reviewTitleInput"
                                        className="form-label fw-semibold text-dark small mb-1"
                                      >
                                        Review Title
                                      </label>
                                      <Field
                                        type="text"
                                        name="title"
                                        id="reviewTitleInput"
                                        placeholder="e.g., Great location and excellent facilities"
                                        autoComplete="off"
                                        className="form-control rounded-2 border-light-subtle"
                                      />
                                    </div>

                                    <div>
                                      <label
                                        htmlFor="reviewContentInput"
                                        className="form-label fw-semibold text-dark small mb-1"
                                      >
                                        Your Feedback
                                      </label>
                                      <Field
                                        name="content"
                                        id="reviewContentInput"
                                        placeholder="Share details about your experience..."
                                        autoComplete="off"
                                        className="form-control rounded-2 border-light-subtle"
                                        as={FormikFieldTextArea}
                                        rows={4}
                                      />
                                    </div>

                                    <div>
                                      <button
                                        className="btn btn-primary text-white fw-semibold rounded-pill px-4 py-2"
                                        type="submit"
                                      >
                                        Submit Review
                                      </button>
                                    </div>
                                  </Form>
                                </div>
                              )}
                            </Formik>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-md-3">
                  <div className="details-sidebar">
                    <div className="contact-owner box-view h-auto p-3 p-md-4 rounded-3 shadow-sm border border-light-subtle">
                      {/* Header Section */}
                      <div className="d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom border-2 border-white">
                        <h3 className="box-title mb-0 fs-5 fw-bold text-dark d-flex align-items-center gap-2">
                          <span
                            className="p-2 rounded-circle bg-white shadow-sm d-flex align-items-center justify-content-center"
                            style={{ width: '32px', height: '32px' }}
                          >
                            👤
                          </span>
                          Contact Owner
                        </h3>
                      </div>

                      {/* Owner Profile Card Header */}
                      <div className="d-flex align-items-center gap-3 p-3 mb-3 rounded-3 bg-white border border-light-subtle shadow-sm">
                        <div className="position-relative flex-shrink-0">
                          <img
                            src={owner?.profileImage || ownerimg}
                            alt="Owner"
                            className="rounded-circle object-fit-cover shadow-sm border"
                            style={{ width: '56px', height: '56px' }}
                          />
                          {propertyDetail?.isOwnerVerified ? (
                            <span
                              className="position-absolute bottom-0 end-0 bg-white rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                              title="Verified Owner"
                              style={{
                                width: '22px',
                                height: '22px',
                                transform: 'translate(2px, 2px)',
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="18px"
                                viewBox="0 -960 960 960"
                                width="18px"
                                fill="#198754"
                              >
                                <path d="m352.46-85.39-71.38-120.3-135.54-29.7 13.23-139.53L66.93-480l91.84-105.08-13.23-139.53 135.54-29.7 71.38-120.3L480-820.46l127.54-54.15 71.38 120.3 135.54 29.7-13.23 139.53L893.07-480l-91.84 105.08 13.23 139.53-135.54 29.7-71.38 120.3L480-139.54 352.46-85.39ZM378-162l102-43.23L583.23-162 640-258l110-25.23L740-396l74-84-74-85.23L750-678l-110-24-58-96-102 43.23L376.77-798 320-702l-110 24 10 112.77L146-480l74 84-10 114 110 24 58 96Zm102-318Zm-42 128.15L650.15-564 608-607.38l-170 170-86-84.77L309.85-480 438-351.85Z" />
                              </svg>
                            </span>
                          ) : (
                            <span
                              className="position-absolute bottom-0 end-0 bg-white rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                              title="Unverified Owner"
                              style={{
                                width: '22px',
                                height: '22px',
                                transform: 'translate(2px, 2px)',
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="18px"
                                viewBox="0 -960 960 960"
                                width="18px"
                                fill="#dc3545"
                              >
                                <path d="m352.46-85.39-71.38-120.3-135.54-29.7 13.23-139.53L66.93-480l91.84-105.08-13.23-139.53 135.54-29.7 71.38-120.3L480-820.46l127.54-54.15 71.38 120.3 135.54 29.7-13.23 139.53L893.07-480l-91.84 105.08 13.23 139.53-135.54 29.7-71.38 120.3L480-139.54 352.46-85.39ZM378-162l102-43.23L583.23-162 640-258l110-25.23L740-396l74-84-74-85.23L750-678l-110-24-58-96-102 43.23L376.77-798 320-702l-110 24 10 112.77L146-480l74 84-10 114 110 24 58 96Zm102-318Zm-42 128.15L650.15-564 608-607.38l-170 170-86-84.77L309.85-480 438-351.85Z M672-240 240-672l33-33 432 432-33 33Z" />
                              </svg>
                            </span>
                          )}
                        </div>

                        <div className="d-flex flex-column overflow-hidden">
                          <h4 className="fs-6 fw-bold text-dark mb-0 text-truncate">
                            {propertyDetail?.OwnerName || 'Property Owner'}
                          </h4>
                          <span className="text-muted small fw-medium">
                            Property Owner
                          </span>
                          <div className="d-flex align-items-center mt-1">
                            <Rating
                              initialValue={ownerRating}
                              SVGstyle={{
                                display: 'inline',
                                height: '14px',
                                width: '14px',
                              }}
                              readonly={true}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Contact Form */}
                      <form
                        onSubmit={handleChatSubmit}
                        className="d-flex flex-column gap-2.5"
                      >
                        {isAuthenticated && (
                          <>
                            <div className="form-group">
                              <label
                                htmlFor="Name"
                                className="form-label text-muted small fw-medium mb-1"
                              >
                                Your Name
                              </label>
                              <input
                                type="text"
                                className="form-control form-control-sm rounded-2 shadow-none border-light-subtle"
                                placeholder="Enter your name"
                                name="Name"
                                value={chatData.Name}
                                onChange={handleChatInputChange}
                                required
                                disabled={
                                  loggedUser?._id === propertyDetail?.user_id
                                }
                              />
                            </div>

                            <div className="form-group">
                              <label
                                htmlFor="Email"
                                className="form-label text-muted small fw-medium mb-1"
                              >
                                Email Address
                              </label>
                              <input
                                type="email"
                                className="form-control form-control-sm rounded-2 shadow-none border-light-subtle"
                                placeholder="Enter your email"
                                name="Email"
                                value={chatData.Email}
                                onChange={handleChatInputChange}
                                required
                                disabled={
                                  loggedUser?._id === propertyDetail?.user_id
                                }
                              />
                            </div>

                            <div className="form-group">
                              <label
                                htmlFor="Message"
                                className="form-label text-muted small fw-medium mb-1"
                              >
                                Message
                              </label>
                              <textarea
                                className="form-control form-control-sm rounded-2 shadow-none border-light-subtle"
                                rows={3}
                                placeholder="Write your message here..."
                                name="Message"
                                value={chatData.Message}
                                onChange={handleChatInputChange}
                                required
                                disabled={
                                  loggedUser?._id === propertyDetail?.user_id
                                }
                              ></textarea>
                            </div>
                          </>
                        )}

                        {/* Buttons Action Area */}
                        <div className="d-flex flex-column gap-2 mt-2">
                          {loggedUser?._id !== propertyDetail?.user_id && (
                            <Button
                              type="submit"
                              className="btn btn-primary w-100 py-2 fw-semibold shadow-sm d-flex align-items-center justify-content-center gap-2"
                              disabled={contactLoading}
                            >
                              {contactLoading && (
                                <img
                                  src={Busy}
                                  alt="loading.."
                                  className="me-1"
                                  style={{ maxWidth: '16px' }}
                                />
                              )}
                              Send Message
                            </Button>
                          )}

                          <button
                            type="button"
                            onClick={handleShowProfile}
                            className="btn btn-outline-secondary w-100 py-2 fw-semibold shadow-sm"
                          >
                            View Owner Profile
                          </button>
                        </div>
                      </form>
                    </div>

                    <div className="box-view h-auto p-3 p-md-4 rounded-3 shadow-sm border border-light-subtle">
                      {/* Header Section */}
                      <div className="d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom border-2 border-white">
                        <h3 className="box-title mb-0 fs-5 fw-bold text-dark d-flex align-items-center gap-2">
                          <span
                            className="p-2 rounded-circle bg-white shadow-sm d-flex align-items-center justify-content-center"
                            style={{ width: '32px', height: '32px' }}
                          >
                            💰
                          </span>
                          Property Fees
                        </h3>
                      </div>

                      {/* Details Key-Value List */}
                      <div className="d-flex flex-column gap-2">
                        {/* Price */}
                        <div className="d-flex align-items-center justify-content-between p-2 px-3 rounded-3 bg-white border border-light-subtle shadow-sm">
                          <span className="text-muted small fw-medium d-flex align-items-center gap-2">
                            <span>🏷️</span> Price
                          </span>
                          <span className="fw-semibold text-dark small">
                            ₹
                            {dealType === dealTypeEnum.Sell
                              ? propertyDetail?.price
                              : selectedRoom?.price}
                          </span>
                        </div>

                        {/* Deposit */}
                        <div className="d-flex align-items-center justify-content-between p-2 px-3 rounded-3 bg-white border border-light-subtle shadow-sm">
                          <span className="text-muted small fw-medium d-flex align-items-center gap-2">
                            <span>🔒</span> Deposit
                          </span>
                          <span className="fw-semibold text-dark small">
                            ₹
                            {dealType === dealTypeEnum.Sell
                              ? propertyDetail?.maintance_fee || 0
                              : selectedRoom?.depositMoney || 0}
                          </span>
                        </div>

                        {dealType !== dealTypeEnum.Sell && (
                          <>
                            {/* Cleaning Fee */}
                            <div className="d-flex align-items-center justify-content-between p-2 px-3 rounded-3 bg-white border border-light-subtle shadow-sm">
                              <span className="text-muted small fw-medium d-flex align-items-center gap-2">
                                <span>🧹</span> Cleaning Fee
                              </span>
                              <span className="fw-semibold text-dark small">
                                ₹{selectedRoom?.cleaningCharges || 0}
                              </span>
                            </div>

                            {/* Pet Fee */}
                            <div className="d-flex align-items-center justify-content-between p-2 px-3 rounded-3 bg-white border border-light-subtle shadow-sm">
                              <span className="text-muted small fw-medium d-flex align-items-center gap-2">
                                <span>🐾</span> Pet Fee
                              </span>
                              <span className="fw-semibold text-dark small">
                                ₹{selectedRoom?.petFees || 0}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>

                    {dealType !== dealTypeEnum.Sell && (
                      <div
                        className="box-view h-auto p-3 p-md-4 rounded-3 shadow-sm border border-light-subtle"
                        // style={{ backgroundColor: '#f8f9fa' }}
                      >
                        {/* Header Section */}
                        <div className="d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom border-2 border-white">
                          <h3 className="box-title mb-0 fs-5 fw-bold text-dark d-flex align-items-center gap-2">
                            <span
                              className="p-2 rounded-circle bg-white shadow-sm d-flex align-items-center justify-content-center"
                              style={{ width: '32px', height: '32px' }}
                            >
                              🏠
                            </span>
                            Property Details
                          </h3>
                        </div>

                        {/* Details Key-Value List */}
                        <div className="d-flex flex-column gap-2">
                          {/* Property Type */}
                          <div className="d-flex align-items-center justify-content-between p-2 px-3 rounded-3 bg-white border border-light-subtle shadow-sm">
                            <span className="text-muted small fw-medium d-flex align-items-center gap-2">
                              <span>🏢</span> Property Type
                            </span>
                            <span className="fw-semibold text-dark text-capitalize small">
                              {proprertyViewData[propertyDetail?.p_type] || '-'}
                            </span>
                          </div>

                          {/* Bedrooms */}
                          <div className="d-flex align-items-center justify-content-between p-2 px-3 rounded-3 bg-white border border-light-subtle shadow-sm">
                            <span className="text-muted small fw-medium d-flex align-items-center gap-2">
                              <span>🛏️</span> Bedrooms
                            </span>
                            <span className="fw-semibold text-dark text-capitalize small">
                              {propertyDetail?.numberOfRooms ?? '-'}
                            </span>
                          </div>

                          {/* Bathroom */}
                          <div className="d-flex align-items-center justify-content-between p-2 px-3 rounded-3 bg-white border border-light-subtle shadow-sm">
                            <span className="text-muted small fw-medium d-flex align-items-center gap-2">
                              <span>🚿</span> Bathroom
                            </span>
                            <span className="fw-semibold text-dark text-capitalize small">
                              {propertyDetail?.isEntireUnit
                                ? propertyDetail?.totalBathroom
                                : selectedRoom?.bathroomType || '-'}
                            </span>
                          </div>

                          {/* Property Status */}
                          <div className="d-flex align-items-center justify-content-between p-2 px-3 rounded-3 bg-white border border-light-subtle shadow-sm">
                            <span className="text-muted small fw-medium d-flex align-items-center gap-2">
                              <span>📌</span> Property Status
                            </span>
                            <span
                              className={`badge rounded-pill fw-semibold px-2 py-1 ${
                                propertyDetail?.is_active
                                  ? 'bg-success-subtle text-success border border-success-subtle'
                                  : 'bg-danger-subtle text-danger border border-danger-subtle'
                              }`}
                            >
                              {propertyDetail?.is_active
                                ? '● Active'
                                : '● Inactive'}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="box-view h-auto p-4 rounded-3 shadow-sm border border-light-subtle">
                      {/* Header Section */}
                      <div className="d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom">
                        <h3 className="box-title mb-0 fs-5 fw-bold text-dark d-flex align-items-center gap-2">
                          📍 Nearby Places
                        </h3>
                        <span className="badge bg-light text-secondary border fw-medium px-2 py-1">
                          Distance
                        </span>
                      </div>

                      {/* Facilities List */}
                      {propertyDetail?.nearby_facilities &&
                      propertyDetail.nearby_facilities.length > 0 ? (
                        <div className="d-flex flex-column gap-2">
                          {propertyDetail.nearby_facilities.map(
                            (nearBy: any, i: number) => (
                              <div
                                key={i}
                                className="d-flex align-items-center justify-content-between py-2 px-3 rounded-2 bg-light-subtle hover-bg-light transition-all"
                              >
                                <div className="d-flex align-items-center gap-2 overflow-hidden me-3">
                                  <span className="text-primary fs-6">🏢</span>
                                  <span
                                    className="fw-medium text-dark text-truncate small"
                                    title={nearBy.address}
                                  >
                                    {nearBy.address || nearBy.name || '-'}
                                  </span>
                                </div>
                                <span className="badge bg-primary-subtle text-primary border border-primary-subtle fw-semibold text-nowrap">
                                  {nearBy.distance} KM
                                </span>
                              </div>
                            )
                          )}
                        </div>
                      ) : (
                        <p className="text-muted small mb-0 py-2">
                          No nearby facilities listed.
                        </p>
                      )}
                    </div>

                    {hasPermission('admin.owner') && (
                      <div className="box-view h-auto admin-action-card">
                        <h3 className="box-title">Property Review</h3>

                        <div className="mb-2">
                          <span className="d-block text-muted small">
                            Document Link:
                          </span>
                          <span>
                            {propertyDetail.docsName ? (
                              <span className="d-flex align-items-center gap-2">
                                {propertyDetail.docsName}
                                <svg
                                  height="20"
                                  viewBox="0 0 24 24"
                                  width="20"
                                  onClick={() => props.documentToggleHandler()}
                                  className="cursor-pointer fill-primary"
                                  style={{ cursor: 'pointer' }}
                                >
                                  <path d="m10 3v2h-5v14h14v-5h2v6c0 .2652-.1054.5196-.2929.7071s-.4419.2929-.7071.2929h-16c-.26522 0-.51957-.1054-.70711-.2929-.18753-.1875-.29289-.4419-.29289-.7071v-16c0-.26522.10536-.51957.29289-.70711.18754-.1875.44189-.29289.70711-.29289zm7.586 2h-4.586v-2h8v8h-2v-4.586l-7 7-1.414-1.414z" />
                                </svg>
                              </span>
                            ) : (
                              'Document Not Available'
                            )}
                          </span>
                        </div>

                        {hasPermission('admin') && (
                          <>
                            {/* Previous Rejection Reason Callout */}
                            {propertyDetail.verificationStatus === 'REJECTED' &&
                              propertyDetail.rejectionReason && (
                                <div className="p-3 mb-3 bg-light border-left border-danger border-4 rounded">
                                  <div className="d-flex align-items-center justify-content-between mb-1">
                                    <span className="badge bg-danger text-white">
                                      REJECTED
                                    </span>
                                    <small className="text-muted">
                                      Admin Note
                                    </small>
                                  </div>
                                  <p className="small text-secondary mb-0">
                                    <strong>Reason:</strong>{' '}
                                    {propertyDetail.rejectionReason}
                                  </p>
                                </div>
                              )}
                            <div className="admin-actions">
                              {!propertyDetail.isApproved ? (
                                <Button
                                  type="button"
                                  className="btn btn-approve flex-fill"
                                  onClick={handleApproveProperty}
                                >
                                  Approve Property
                                </Button>
                              ) : (
                                <Button
                                  type="button"
                                  className="btn btn-reject flex-fill"
                                  onClick={() => setShowRejectModal(true)}
                                >
                                  Reject Property
                                </Button>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Rejection Reason Modal */}
      {showRejectModal && (
        <div className="custom-modal-backdrop">
          <div className="custom-modal">
            <h4 className="modal-title">Reason for Rejection</h4>
            <p className="text-muted small">
              Please specify why this property listing is being rejected. This
              explanation will be sent directly to the property owner.
            </p>
            <form onSubmit={handleRejectSubmit}>
              <textarea
                className="form-control"
                rows={4}
                placeholder="Enter detailed reason for rejection..."
                value={rejectionReason}
                onChange={(e) => setRejectionReason(e.target.value)}
                required
              ></textarea>
              <div className="modal-actions">
                <Button
                  type="button"
                  variant="secondary"
                  onClick={() => {
                    setShowRejectModal(false);
                    setRejectionReason('');
                  }}
                >
                  Cancel
                </Button>
                <Button type="submit" variant="danger">
                  Confirm Rejection
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default DocumentPopupHOC(
  SignUpPopupHOC(SignInPopupHOC(CalenderPopupHOC(PropertyDetail)))
);
